import {a4d_axiosHelpers} from "@helpers/a4d_axiosHelpers";

export function initAxiosHelpers() {
    if (!window.a4dAxios) {
        window.a4dAxios = a4d_axiosHelpers;
    }
    return window.a4dAxios;
}
